import React, { useState } from "react";
import axios from "axios";
import { environment } from "../../environments/environments";
import "../DocumentUpload/DocumentUpload.css";
import { useNavigate } from "react-router-dom";
import bgImage from "../../assets/images/brown-background.jpg";
import Swal from "sweetalert2";
import RegistraionFlowHeader from "../RegistraionFlowHeader/RegistraionFlowHeader";

const DocumentUpload = () => {
  const navigate = useNavigate();
  const [imageFile, setImageFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const MAX_FILE_SIZE = 2 * 1024 * 1024;

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const allowedTypes = ["image/jpeg", "image/png", "application/pdf"];
    if (!allowedTypes.includes(file.type)) {
      Swal.fire({
        icon: "error",
        title: "Invalid file type",
        text: "Only JPG, PNG, or PDF files are allowed.",
      });
      return;
    }

    if (file.size > MAX_FILE_SIZE) {
      Swal.fire({
        icon: "error",
        title: "File too large",
        text: "The selected file exceeds the maximum size of 2MB.",
      });
      return;
    }

    setImageFile(file);

    if (file.type.startsWith("image/")) {
      setPreviewUrl(URL.createObjectURL(file));
    } else {
      setPreviewUrl(null);
    }
  };

  const handleUpload = async () => {
    if (!imageFile) {
      Swal.fire({
        icon: "warning",
        title: "No file selected",
        text: "Please select a document before uploading.",
      });
      return;
    }

    setIsLoading(true);
    try {
      const userDatas = localStorage.getItem("currentUser");
      const parsedUserData = JSON.parse(userDatas);
      const userId = parsedUserData?.id || parsedUserData?._id;

      const formData = new FormData();
      formData.append("user_id", userId);
      formData.append("profile_completion_status", "cultureReligion");
      formData.append("user_document", imageFile);

      const response = await axios.post(
        `${environment.baseURL}/updateuser`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      console.log("api response", JSON.stringify(response));
      if (response.data?.success) {
        navigate("/interest");
      } else {
        Swal.fire({
          icon: "error",
          title: "Upload Failed",
          text: response.data?.message || "Something went wrong!",
        });
      }
    } catch (error) {
      console.error("Upload Error:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong during the upload.",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div
      className="DocumentUploadcontainer sechdr-toppding"
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="containerall">
        <RegistraionFlowHeader />
        <div className="DocUploadcontall">
          <h2 className="uploadDoucmentheader">Upload Document</h2>
          <p className="instructions">
            Tap to upload an image or PDF of your ID proof.
          </p>

          <label className="upload-box">
            <input
              type="file"
              accept="image/*,application/pdf"
              onChange={handleFileChange}
              hidden
            />
            {previewUrl ? (
              <img src={previewUrl} alt="Selected" className="uploaded-image" />
            ) : imageFile?.type === "application/pdf" ? (
              <p className="upload-placeholder">{imageFile.name}</p>
            ) : (
              <span className="upload-placeholder">
                Click to select an image or PDF
              </span>
            )}
          </label>

          <button
            className="upload-button"
            onClick={handleUpload}
            disabled={isLoading}
          >
            {isLoading ? "Uploading..." : "Continue"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DocumentUpload;
